import React from "react";
import { FileText } from "lucide-react";
import CompanyFormsPageHeader from "./CompanyFormsPageHeader";

export default function CompanyFormsApprovePageHeader({ actions = null }) {
  return (
    <CompanyFormsPageHeader
      icon={FileText}
      title="Approve documents"
      subtitle="Review new uploads, then approve or reject."
      actions={actions}
    />
  );
}
